import { HelperText } from '~/components/helper-text'
import type { TIconProps } from '~/components/icon'
import { useInputTextProps } from '../../hooks'

export const InputHelperText = ({
  children,
  withIcon = false,
  iconName = 'rdicon-warning-circle',
}: {
  children: React.ReactNode
  withIcon?: boolean
  iconName?: TIconProps['symbol']
}) => {
  const { hasError, disabled, readonly } = useInputTextProps()

  return !hasError ? (
    <HelperText
      disabled={disabled}
      readonly={readonly}
      withIcon={withIcon}
      iconName={iconName}
      iconSize="tiny"
    >
      {children}
    </HelperText>
  ) : null
}
